"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlider = _interopRequireDefault(require("react-slider"));

require("./range-slider.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
  Range slider config comes from https://github.com/mpowaga/react-slider
  passed forward for use.
*/
var RangeSlider = function RangeSlider(props) {
  return _react["default"].createElement(_reactSlider["default"], _extends({
    pearling: true
  }, props, {
    className: "RangeSlider ".concat(props.className)
  }));
};

RangeSlider.propTypes = {
  className: _propTypes["default"].string
};
RangeSlider.defaultProps = {
  className: ''
};
var _default = RangeSlider;
exports["default"] = _default;